export { NgHeadingComponent } from './ng-heading.component';
